import React from "react";
import "./Greeting.css";
import { contributors, greeting } from "../../shared/constants";
import { Fade } from "react-awesome-reveal";
import { Images } from "../../assets/images";
import Contributors from "../contributors/Contributors";
import Button from "../Button/Button";

export default function Greeting(props: { theme: any }) {
  return (
    <section className="section section-lg section-shaped pb-250">
      <div className="shape shape-style-1 bg-gradient-info">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-image-div">
            <img className="logoImage" alt="logo" src={Images.Logo}></img>
          </div>
          <div className="greeting-text-div">
            <div>
              <h1 style={{ color: "#fff" }} className="greeting-text">
                {greeting.title}
              </h1>
              <p style={{ color: "#fff" }} className="greeting-text-p subTitle">
                {greeting.subTitle}
              </p>
              <Contributors logos={contributors} />
              <div className="resume-btn-div">
                <Button
                  text="FIVERR ACCOUNT"
                  newTab={true}
                  href="https://firebasestorage.googleapis.com/v0/b/codinglerds.appspot.com/o/Nishankar_CV.pdf?alt=media&token=2385dfc0-d3a4-49ed-9519-3ab00172a32a"
                  theme={props.theme}
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-link" />
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="separator separator-bottom separator-skew">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon className="fill-white" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </section>
    // </Fade>
  );
}
